// 模块化vuex数据
// getter调用示例：this.$store.getters['moduleA/moduleState']

const state = {
  _moduleState: 'im a moduleState'
};

const getters = {
  moduleState: (state) => state._moduleState
};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
